import { render, staticRenderFns } from "./PlanEditWrapper.vue?vue&type=template&id=6f798c47&scoped=true"
import script from "./PlanEditWrapper.vue?vue&type=script&lang=ts"
export * from "./PlanEditWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PlanEditWrapper.vue?vue&type=style&index=0&id=6f798c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f798c47",
  null
  
)

export default component.exports